<script>
    export let buttonStyle, buttonSize;
    const STYLES = [
        'btn--primary--outline',
        'btn--warning--outline',
        'btn--danger--outline',
        'btn--success--outline',
        'btn--simple',
        'btn--cercle',
        'btn--primary--solid',
        'btn--warning--solid',
        'btn--danger--solid',
        'btn--success--solid',
        'btn--solid',
    ];

    const SIZES = ['btn--medium', 'btn--large','btn--xlarge', 'btn--small'];

    const checkButtonStyle = STYLES.includes(buttonStyle) ? buttonStyle : STYLES[0];
    const checkButtonSize = SIZES.includes(buttonSize) ? buttonSize : SIZES[0];
</script>

<button
    class="btn {checkButtonStyle} {checkButtonSize}"
    on:click
>
    <slot></slot>
</button>